    import './kp-main-menu-logo-image.less';

/**
 * @ngdoc component
 * @name kpMainMenuLogoImage
 * @module portaro.components.main-menu
 *
 * @param {number} width Logo width. Default: 48px.
 *
 * @description
 * Insert CSSly pre-defined image into {@link component:kpMainMenuLogo}
 */

export default class MainMenuLogoImageComponent {
    static componentName = 'kpMainMenuLogoImage';

    template = ['CONTEXT_PATH', (CONTEXT_PATH) => `<div class="main-menu-logo-image" ng-style="{width: mmlicc.width}" style="background-image: url('${CONTEXT_PATH}/custom/design/main-menu-logo.png');"></div>`];
    bindings = {
        width: '@?'
    };
    controllerAs = 'mmlicc';
}